
/**
 * Utility to ensure all asset paths use the correct base path
 * Optimized for baabaa.app domain
 * @param path - The path to the asset
 * @returns The complete URL to the asset
 */
export const getAssetPath = (path: string): string => {
  // If the path already starts with http/https, return it as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // For relative paths, ensure they start with a slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Use window.location.origin to get the current site origin
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  
  // Create the final path by joining the origin and the normalized path
  const finalPath = `${origin}${normalizedPath}`;
  
  console.log(`Asset path resolved: ${path} → ${finalPath}`);
  return finalPath;
};

/**
 * Generates a QR code URL for the current application
 * Optimized for baabaa.app domain
 * @returns URL to QR code image
 */
export const getQRCodeUrl = (): string => {
  // Get the canonical URL of the application
  const appUrl = typeof window !== 'undefined' 
    ? window.location.href.split('#')[0].split('?')[0]
    : 'https://baabaa.app';
  
  // Log the URL being used for the QR code
  console.log("Generating QR code for URL:", appUrl);
  
  // Use a reliable QR code service with the app URL
  return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(appUrl)}`;
};
